import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createList } from '../../actions/data';
import { storeWithExpiration } from '../../utils/common';
import { SUPER_ADMIN } from '../../config/app_config';

import NameListForm from './NameListForm';

const FORM_ID = 'nameListForm';
const PAGE_NUM = 1;

export class NameListFormContainer extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    accountId: PropTypes.number.isRequired,
    invalid: PropTypes.bool.isRequired,
    createListAction: PropTypes.func.isRequired,
    resetPageFunction: PropTypes.func.isRequired,
  };

  performCreateList = params => {
    const { createListAction, accountId, isSuperAdmin } = this.props;
    const token = storeWithExpiration.get('token');
    const listInfo = {
      datasetName: params.listName,
    };
    createListAction(token, listInfo, accountId, PAGE_NUM, isSuperAdmin);
  };

  render() {
    const { handleSubmit, invalid, submitting, resetPageFunction } = this.props;

    return (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body">
              <div className="row">
                <div className="col-sm-12">
                  <h1 className="header-title">New List</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <NameListForm
                handleSubmit={handleSubmit}
                createListFunction={this.performCreateList}
                submitting={submitting}
                invalid={invalid}
                resetPageFunction={resetPageFunction}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.fileName || values.fileName === '') {
    errors.fileName = 'Required';
  }
  if (!values.listName || values.listName === '') {
    errors.listName = 'Required';
  }
  return errors;
};

const mapStateToProps = state => {
  const { user } = state;
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  return { isSuperAdmin };
};

const NameListFormContainerRF = reduxForm({
  form: FORM_ID,
  validate,
})(NameListFormContainer);

export default connect(
  mapStateToProps,
  {
    createListAction: createList,
  }
)(NameListFormContainerRF);
